/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ContentSummaryInfo = {
    CTTP: ContentSummaryInfo.CTTP;
    CID: string;
    TB: string;
    TI: string;
    PDT: string;
    SM: string;
    CATG: string;
};

export namespace ContentSummaryInfo {

    export enum CTTP {
        RESEARCH = 'RESEARCH',
        NOTICE = 'NOTICE',
        EVENT = 'EVENT',
        BLOG = 'BLOG',
    }


}

